import en from "../locales/en/translation.json";
import fr from "../locales/fr/translation.json";
import nl from "../locales/nl/translation.json";

export const DEFAULT_LANG = "en";

export const SUPPORTED_LANGS = ["en", "fr", "nl"];

export const RESOURCES = {
  en: { translation: en },
  fr: { translation: fr },
  nl: { translation: nl },
};
